import BasicValidation from 'components/components/common/BasicValidation';

export default class KidsSafetyValidation extends BasicValidation {

  constructor(props){
    super();
    this.props = props;
  }

  sumKidsSafety(){
    var sum = 0;
    for(var key in this.props.kidsSafety){
      sum += this.props.kidsSafety[key];
    }
    return sum;
  }

  disableIncrement(){
    return this.sumKidsSafety() >= this.props.childrenNumber;
  }

  itemsToChooseLeft(){
    return this.props.childrenNumber - this.sumKidsSafety();
  }

  isValidForm(){
    return this.itemsToChooseLeft() === 0;
  }

}
